import { Slide, ToastPosition } from 'react-toastify'

export const toastConfig = {
  position: 'top-left' as ToastPosition,
  autoClose: 4000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  transition: Slide,
  bodyStyle: {
    fontSize: '15px',
  },
  // Override the default toast container styles:
  toastStyle: {
    width: 'auto', // Allow the toast to size based on its content
    minWidth: 'auto', // Remove any fixed min-width
    maxWidth: 'none', // Remove the max-width limitation
  },
}
